import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Observable } from "rxjs";
import {
  ApiResponseModel,
  ApiVisa,
  BaseApiTemplateService,
  Core2Config,
} from "../../shared";
import { PKCRequestBodyModel } from "../../../../../../models/dbschema";
import { PKCResponseDto } from "../../../data-transfer-objects/pkc-response-dto.model";
import { PublicKeyResponseDto } from "../../../data-transfer-objects/public-key-response-dto.model";
import { PrivateKeyResponseDto } from "../../../data-transfer-objects/private-key-response-dto.model";

@Injectable({ providedIn: "root" })
export class KeyGenerationService extends BaseApiTemplateService<any> {
  constructor(http: HttpClient) {
    super();
    this.apiUrl =
      Core2Config.DOMAIN_URL +
      Core2Config.TENANT_DOMAIN_URL_PREFIX +
      Core2Config.ERP_PREFIX +
      "pricebook-rules";
    this.endpoint_path =
      Core2Config.TENANT_DOMAIN_URL_PREFIX +
      Core2Config.ERP_PREFIX +
      "pricebook-rules";
    this.httpClient = http;
  }

  generateKeys(
    websiteHdrGuid: string,
    requestData: PKCRequestBodyModel,
    visa: ApiVisa
  ): Observable<any> {
    let url = visa.api_domain_url + this.endpoint_path + "/key-generation/" + websiteHdrGuid;
    if (this.endpoint_path && visa.api_domain_url) {
      url =
        visa.api_domain_url +
        this.endpoint_path +
        "/key-generation/" +
        websiteHdrGuid;
    }
    return this.httpClient.post<ApiResponseModel<PKCResponseDto>>(
      url,
      requestData,
      this.getHttpHeader(visa)
    );
  }

  getPublicKey(websiteHdrGuid: string, visa: ApiVisa): Observable<any> {
    let url = visa.api_domain_url + this.endpoint_path + "/public-key-retrieval/" + websiteHdrGuid;
    if (this.endpoint_path && visa.api_domain_url) {
      url =
        visa.api_domain_url +
        this.endpoint_path +
        "/public-key-retrieval/" +
        websiteHdrGuid;
    }
    return this.httpClient.get<ApiResponseModel<PublicKeyResponseDto>>(
      url,
      this.getHttpHeader(visa)
    );
  }

  getPrivateKey(websiteHdrGuid: string, visa: ApiVisa): Observable<any> {
    let url =  visa.api_domain_url + this.endpoint_path + "/private-key-retrieval/" + websiteHdrGuid;
    if (this.endpoint_path && visa.api_domain_url) {
        url =
          visa.api_domain_url +
          this.endpoint_path +
          "/private-key-retrieval/" +
          websiteHdrGuid;
      }
      return this.httpClient.get<ApiResponseModel<PrivateKeyResponseDto>>(
        url,
        this.getHttpHeader(visa)
      );
  }
}
